import React, { Fragment, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toastr } from "react-redux-toastr";
import api from "../../../../api";
import Dropzone from "react-dropzone";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { MediaFile } from "../../../../core/api/models";
import { IAddLeadActivityModel } from "../../../../core/api/models/lead";
import { useLeadActivities } from "../../../../core/hooks/useLeadActivities";

interface IAddNoteActivityProps {
  leadId?: string;
  documentId?: string;
  onSubmitCompleted?: () => void;
  allActvity?: boolean;
}

export const AddFileActivity: React.FunctionComponent<IAddNoteActivityProps> = (
  props
) => {
  const { addLeadActivity } = useLeadActivities(api.lead);
  const [showEditor, setShowEditor] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [file, setFile] = useState<MediaFile>();
  const [canSave, setCanSave] = useState<boolean>(false);
  const [isSaving, setSaving] = useState(false);

  const { control, handleSubmit, errors, setValue } = useForm<{
    fileName?: string;
    file: MediaFile;
    leadId?: string;
  }>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const loadExistingFile = async (leadId?: string) => {
    const activities = await api.lead.getLeadActivities(
      leadId || "",
      "completed",
      {
        page: 1,
        type: "file",
      }
    );
    if (!file && activities && activities.data && activities.data.length > 0) {
      setFile(activities.data[0].file);
    }
  };

  React.useEffect(() => {
    if (!props.allActvity) {
      // loadExistingFile(props.leadId);
    }
  }, []);

  const onFileSubmit = (data: {
    fileName?: string;
    file?: MediaFile;
    leadId?: string;
  }) => {
    const apiModel: IAddLeadActivityModel = {
      type: "file",
      title: data.fileName || "",
      leadId: data.leadId as any,
      documentId: props.documentId as any,
      file,
    };
    setSaving(true)
    addLeadActivity(apiModel, () => {
      toastr.success("Success", "File uploaded successfully");
      setShowEditor(false);
      props.onSubmitCompleted?.();
      setFile(undefined);
      setSaving(false)
    });
  };

  const handleDrop = async (acceptedFiles: any) => {
    setFile(undefined);
    setUploading(true);
    try {
      const uploadedResponse = await api.upload.upload(
        acceptedFiles[0],
        onProgress
      );

      setFile(uploadedResponse.data);
      setValue("file", uploadedResponse.data);
      setCanSave(true);
    } catch (error) {
      if (error?.response?.data?.message) {
        toastr.error("Error", error?.response?.data?.message);
      } else {
        toastr.error("Error", "File upload failed");
      }
    }
    setUploading(false);
  };

  const onProgress = (event: ProgressEvent) => {
    const progressPercentage = event.loaded / event.total;
    setProgress(progressPercentage);
  };
  const deleteFile = () => {
    setFile(undefined);
    setValue("file", undefined);
    setCanSave(false);
  };

  const renderLeadOption = () => {
    return (
      <Controller
        control={control}
        rules={{ required: "Lead is Required" }}
        name="leadId"
        defaultValue={props.leadId}
        render={() => <></>}
      />
    );
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onFileSubmit)}>
        <Fragment>
          <div className="col-sm-12 col-12 pt-3">
            {!file ? (
              <div className="form-group font-weight-semibold mb-3">
                <Dropzone onDrop={handleDrop} multiple={false}>
                  {({ getRootProps, getInputProps }) => (
                    <div
                      {...getRootProps({
                        className:
                          "border py-5 px-5 font-xs text-center bg-lightblue",
                      })}
                    >
                      Drag files here
                      <span className="text-gray-400 px-1">or</span>
                      <label
                        htmlFor="selectFiles"
                        className="text-primary cursor-pointer mb-0"
                      >
                        <input {...getInputProps()} className="d-none" />
                        select from your computer
                      </label>
                    </div>
                  )}
                </Dropzone>
                {errors.file && <ErrorMessage>File is required</ErrorMessage>}
              </div>
            ) : (
              <>
                <div className="bg-gray-100 font-md font-weight-semibold form-group mb-3 pb-3 pl-2 pt-3">
                  {file.originalname}
                  <i
                    className="float-right icon-bin-fill pr-2 cursor-pointer"
                    onClick={deleteFile}
                  ></i>
                </div>
              </>
            )}
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                name="fileName"
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!value.trim();
                  },
                }}
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control font-weight-semibold"
                    placeholder="File Name"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="fileName"
                  />
                )}
              />
              {errors.fileName && errors.fileName.type === "required" && (
                <ErrorMessage>file name is required</ErrorMessage>
              )}
            </div>
            {renderLeadOption()}
          </div>
          <div className="border-bottom border-top container-fluid py-2 text-right">
            <button
              disabled={!canSave || isSaving}
              className="btn btn-primary font-normal font-weight-semibold py-2"
            >
              Save
            </button>
          </div>
        </Fragment>
      </form>
    </div>
  );
};
